import SuperscriptNode from './SuperscriptNode'
import SuperscriptButton from './SuperscriptButton'

const TYPE = 'Superscript'
const TRIGGER_KEY = '.'

const hasSuperscript = state => state.marks.count() && state.marks.some(mark => mark.type === TYPE)

const SuperscriptSchema = {
  marks: {
    Superscript: SuperscriptNode
  }
}

const onKeyDown = (event, data, state) => {
  if (data.isMod && data.key === TRIGGER_KEY) return onApply(state)
}

const onClickButton = (e, state) => {
  e.preventDefault()
  return onApply(state)
}

const onApply = state => {
  return state
    .transform()
    .toggleMark(TYPE)
    .focus()
    .apply()
}

const SuperscriptPlugin = options => {
  return {
    schema: SuperscriptSchema,

    onKeyDown (...args) {
      return onKeyDown(...args)
    }
  }
}

export {
  TYPE,
  TRIGGER_KEY,
  hasSuperscript,
  onClickButton,
  SuperscriptPlugin,
  SuperscriptSchema,
  SuperscriptNode,
  SuperscriptButton
}



// WEBPACK FOOTER //
// ./src/components/SuperscriptSlatePlugin/SuperscriptSlatePluginContainer.js